export const SERVER_URL = 'https://tek.atysoft.ro';
// export const SERVER_URL = 'http://tek.test';
export const ROWS_PER_PAGE = 25;
export const TOP_DEFAULT_CONFIG = {
  pullText: 'Trage în jos pentru reîncărcare', // The text is displayed when you pull down
  triggerText: 'Ridică degetul pentru reîncărcare', // The text that appears when the trigger distance is pulled down
  loadingText: 'Se încarcă...', // The text in the load
  doneText: '', // Load the finished text
  failText: 'Eroare la reîncărcare', // Load failed text
  loadedStayTime: 1, // Time to stay after loading ms
  stayDistance: 50, // Trigger the distance after the refresh
  triggerDistance: 70 // Pull down the trigger to trigger the distance
};
